import { Component, OnDestroy, OnInit } from '@angular/core';
import {NotificationsService, ProjectService} from '@catcore/services';
import {Project} from '@catcore/types/api-v2';
import {ProjectOptionTokensService} from '@catmodels/project-option-tokens/services/project-option-tokens.service';
import {ProjectOptionTokenListItem, ProjectOptionTokensResponse} from '@catmodels/project-option-tokens/types';
import {StyleType} from '@catui/types';
import {Subscription} from 'rxjs';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'catapp-project-option-tokens',
  templateUrl: './project-option-tokens.component.html',
  styleUrls: ['./project-option-tokens.component.scss'],
})
export class ProjectOptionTokensComponent implements OnInit, OnDestroy {

  tableItems: ProjectOptionTokenListItem[] = [];
  dataTableInitialized = false;
  styleType = StyleType;

  columns = {
    feature: {field: 'feature', header: 'Feature'},
    description: {field: 'description', header: 'Description'},
    value: {field: 'value', header: 'Value'},
    active: {field: 'active', header: 'Active'},
  };

  private projectSubscription: Subscription;
  private project: Project;
  private tokens: ProjectOptionTokensResponse;

  constructor(private projectService: ProjectService,
              private projectTokensService: ProjectOptionTokensService,
              private notificationService: NotificationsService) { }

  ngOnInit() {
    this.projectSubscription = this.projectService.getCurrentProject().subscribe((project) => {
      this.project = project;
      if (this.project !== null && this.project.id !== null) {
        const subscr = this.projectService.getProjectTokens(this.project)
          .finally(() => {
            subscr.unsubscribe();
          })
          .subscribe((tokens: any) => {
            this.dataTableInitialized = true;
            this.projectTokensService.setActive();
            if (tokens) {
              this.tokens = tokens;
              this.updateData();
            } else {
              this.tokens = null;
            }
          });
      }
    });
  }

  ngOnDestroy() {
    if (!isNullOrUndefined(this.projectSubscription)) {
      this.projectSubscription.unsubscribe();
    }
    this.projectTokensService.setInActive();
    this.dataTableInitialized = false;
  }

  dataAvailable() {
    return this.tokens !== null;
  }

  activate(token) {
    const subscr = this.projectTokensService.activateToken(token, true)
      .finally(() => {subscr.unsubscribe(); })
      .subscribe((token) => {
        this.updateTokens();
      });
  }

  deactivate(token) {
    const subscr = this.projectTokensService.activateToken(token, false)
      .finally(() => {subscr.unsubscribe(); })
      .subscribe((token) => {
        this.updateTokens();
      });
  }

  private updateTokens() {
    const subscr = this.projectService.getProjectTokens(this.project)
      .finally(() => {
        subscr.unsubscribe();
      })
      .subscribe((tokens: any) => {
        if (tokens) {
          this.tokens = tokens;
          this.updateData();
        } else {
          this.tokens = null;
        }
      });
  }

  private updateData() {
    this.tableItems = this.projectTokensService.extractTokensFromResponse(this.tokens);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-option-tokens/components/project-option-tokens/project-option-tokens.component.ts